// Default doc counts - will be overridden by actual data
export const DOC_COUNTS_DEFAULT = [0, 1, 3, 5, 10, 20, 32];

// Helper to generate appropriate doc counts based on data length
export const getDocCountsForLength = (length) => {
  if (length === 2) return [0, 10];
  if (length === 3) return [0, 1, 5];
  if (length === 4) return [0, 1, 3, 5];
  if (length === 5) return [0, 1, 3, 5, 10];
  if (length === 6) return [0, 1, 3, 5, 10, 20];
  if (length === 7) return [0, 1, 3, 5, 10, 20, 32];
  // For any other length, generate evenly spaced values
  if (length <= 1) return [10];
  const result = [];
  for (let i = 0; i < length; i++) {
    result.push(i === 0 ? 0 : i === length - 1 ? 32 : Math.round((32 * i) / (length - 1)));
  }
  return result;
};

// Legacy export for backward compatibility
export const DOC_COUNTS = DOC_COUNTS_DEFAULT;

export const LANGUAGES = ['EN', 'ES', 'FR', 'IT', 'EU', 'KK'];

export const LANGUAGE_NAMES = {
  'EN': 'English',
  'ES': 'Spanish',
  'FR': 'French',
  'IT': 'Italian',
  'EU': 'Basque',
  'KK': 'Kazakh'
};

export const COLORS = {
  'EN': '#3B82F6', // Blue-500
  'ES': '#EF4444', // Red-500
  'FR': '#10B981', // Emerald Green-500
  'IT': '#F59E0B', // Amber-500
  'EU': '#8B5CF6', // Violet-500
  'KK': '#06B6D4'  // Cyan-500
};

// Dark mode colors for languages
export const COLORS_DARK = {
  'EN': '#60A5FA', // Blue-400
  'ES': '#F87171', // Red-400
  'FR': '#34D399', // Emerald Green-400
  'IT': '#FBBF24', // Amber-400
  'EU': '#A78BFA', // Violet-400
  'KK': '#22D3EE'  // Cyan-400
};

// Experimental setting colors
export const SETTING_COLORS = {
  'monolingual': '#10B981',    // Green
  'multilingual': '#8B5CF6',   // Purple
  'cross-lingual': '#F59E0B'   // Amber
};

export const SETTING_COLORS_DARK = {
  'monolingual': '#34D399',
  'multilingual': '#A78BFA',
  'cross-lingual': '#FBBF24'
};

export const SETTINGS = ['monolingual', 'multilingual', 'cross-lingual'];

export const SETTING_DESCRIPTIONS = {
  'monolingual': 'Training and testing in the same language',
  'multilingual': 'Training with multiple languages simultaneously',
  'cross-lingual': 'Training in one language, testing in another'
};

export const CHART_COLORS = [
  '#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6', '#06B6D4',
  '#EC4899', '#84CC16', '#F97316', '#6366F1', '#14B8A6', '#F59E0B'
];

export const CHART_COLORS_DARK = [
  '#60A5FA', '#F87171', '#34D399', '#FBBF24', '#A78BFA', '#22D3EE',
  '#F472B6', '#A3E635', '#FB923C', '#818CF8', '#2DD4BF', '#FBBF24'
];

export const VIEW_TYPES = [
  { value: 'lines', label: 'Line Chart', icon: '📈' },
  { value: 'bars', label: 'Bar Chart', icon: '📊' },
  { value: 'scatter', label: 'Scatter Plot', icon: '⚫' },
  { value: 'area', label: 'Area Chart', icon: '📉' },
  { value: 'heatmap', label: 'Heatmap', icon: '🗺️' },
  { value: 'radar', label: 'Radar Chart', icon: '🎯' },
  { value: 'settingComparison', label: 'Setting Comparison', icon: '⚖️' },
  { value: 'methodComparison', label: 'Method Comparison', icon: '🔄' },
  { value: 'statistical', label: 'Statistical Analysis', icon: '📐' },
  { value: 'comprehensive', label: 'Comprehensive Overview', icon: '🔍' }
];

export const DEFAULT_GOOGLE_SHEETS_URL = 'https://docs.google.com/spreadsheets/d/1-ZQVDMTlnpaUjb2wMAKUS7GurZN8lJTqFoY4L09K2z0/edit?gid=0#gid=0';